import http from './default'

export default class HideEedService {
  static async getHidden(client) {
    return http.get(
      `${process.env.REACT_APP_HIDE_EED_FIELDS}/v1/hide/${client}`,
    )
  }

  static async postHidden(clients, fields) {
    var body = []
    const clientsArr = clients.map(client => client.value)
    const clientsStr = clientsArr.join(',')
    const fieldsArr = Object.keys(fields).filter(key => fields[key])
    const fieldsStr = fieldsArr.join()
    const ask = { clients: clientsStr, fields: fieldsStr }
    body.push(ask)
    return await http.post(
      `${process.env.REACT_APP_HIDE_EED_FIELDS}/v1/hide`,
      body,
    )
  }
}
